import { Environment } from "types";

export const environment = {
  env: Environment.LAB,
  apiURL: "https://api.lab.deskbird.com",
  appURL: "https://portal-lab.deskbird.com",
};
